import { Link } from 'react-router-dom';
import './Footer.scss';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div className="footer-col footer-brand">
          <img src="/logo-footer.png" alt="好美意" className="footer-logo-img" />
          <div className="footer-logo">好美意</div>
          <p>好家好美意，装点每一个家</p>
          <p className="footer-slogan">家装场景服务 · 家装优选商城 · 装修现场勘验 · 一站式家居解决方案</p>
        </div>
        <div className="footer-col">
          <h4>快速导航</h4>
          <Link to="/">首页</Link>
          <Link to="/about">关于我们</Link>
          <Link to="/services">产品服务</Link>
          <Link to="/contact">联系我们</Link>
        </div>
        <div className="footer-col">
          <h4>产品服务</h4>
          <Link to="/services">全屋家具定制</Link>
          <Link to="/services">精品成品家具</Link>
          <Link to="/services">整体软装设计</Link>
          <Link to="/services?category=survey">勘察服务</Link>
        </div>
        <div className="footer-col">
          <h4>联系方式</h4>
          <span>客服热线：021-64157750</span>
          <span>邮箱：service@Homeez.cn</span>
          <span>地址：上海市徐汇区徐虹北路20号3楼305</span>
          <span>营业时间：周一至周五 9:00-21:00</span>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-copyright">
            © {new Date().getFullYear()} 云之富（上海）数据服务有限公司 版权所有
          </div>
          <div className="footer-beian">
            <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
              沪ICP备18037260号-1
            </a>
            <span className="beian-sep">|</span>
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402333780"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/beiAn.png" alt="" className="beian-badge" aria-hidden="true" />
              沪公网安备31010402333780号
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
